import React from 'react';

import ExplorerIcon from 'components/FileViewer/ExplorerIcon';

import './index.scss';

export default function EmptyState({
  query,
  isRoot,
  canUpload,
  onSearchEverywhere,
  companyName,
  onShowAllCompanies,
}: {
  /** Termo digitado (vazio = pasta sem conteúdo). */
  query: string;
  isRoot: boolean;
  canUpload: boolean;
  /** Presente quando a busca foi só nesta pasta. */
  onSearchEverywhere?: () => void;
  /** Admin com empresa escolhida: o nome dela no vazio da raiz. */
  companyName?: string;
  /**
   * Admin ainda sem empresa (estado "Escolha uma empresa"): a tela não pediu a lista, e o botão
   * abre a visão própria ("Todas as empresas").
   */
  onShowAllCompanies?: () => void;
}) {
  if (onShowAllCompanies) {
    return (
      <div className="file-explorer-empty">
        <span className="file-explorer-empty-art" aria-hidden="true">
          <ExplorerIcon name="folder" size={28} strokeWidth={1.6} />
        </span>
        <p className="file-explorer-empty-title">Escolha uma empresa</p>
        <p className="file-explorer-empty-text">
          Escolha no campo “Empresa” acima para ver os arquivos exatamente como essa empresa os vê.
        </p>
        <button
          type="button"
          className="file-explorer-empty-action is-secondary"
          onClick={onShowAllCompanies}
        >
          Ver todas as empresas
        </button>
      </div>
    );
  }

  const term = query.trim();
  let title = 'Esta pasta está vazia';
  let text = 'Os arquivos publicados para você aparecem aqui.';
  if (term) {
    title = `Nada encontrado para “${term}”`;
    text = 'Verifique a grafia ou tente outro termo.';
  } else if (isRoot) {
    title = 'Nenhuma pasta disponível';
    text = companyName
      ? `Quando houver arquivos para ${companyName}, eles aparecem aqui.`
      : 'Quando houver arquivos para a sua empresa, eles aparecem aqui.';
  } else if (canUpload) {
    text = 'Arraste arquivos para cá ou use “Enviar arquivos”.';
  }

  return (
    <div className="file-explorer-empty">
      <span className="file-explorer-empty-art" aria-hidden="true">
        <ExplorerIcon name={term ? 'search' : 'folderOpen'} size={28} strokeWidth={1.6} />
      </span>
      <p className="file-explorer-empty-title">{title}</p>
      <p className="file-explorer-empty-text">{text}</p>
      {term && onSearchEverywhere && (
        <button type="button" className="file-explorer-empty-action" onClick={onSearchEverywhere}>
          Buscar em todas as pastas
        </button>
      )}
    </div>
  );
}
